import Home from "./Home";

export default function HomeIndex() {
  return (
    <>
      <Home />
    </>
  );
}
